var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOutrosImoveisCasa = function SvgOutrosImoveisCasa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#D3D4DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8109 19.0542C41.9703 18.3507 41.0331 18 39.9991 18C38.9673 18 38.028 18.3507 37.1874 19.0542L19.6359 33.2061C19.0286 33.9411 18.8563 34.737 19.119 35.5917C19.3817 36.4485 20.0184 36.8769 21.0334 36.8769L23.1937 36.9L23.2021 55.8C23.2021 58.5993 24.6038 59.9916 27.4051 59.9706H31.608C34.4092 59.9496 48.4197 60 48.4197 60H52.6227C55.4239 60 56.8256 58.5993 56.8256 55.8V36.9L58.8934 36.8769C59.8643 36.8727 60.5137 36.4464 60.8415 35.5917C61.1693 34.7391 60.9886 33.9474 60.2993 33.2145L42.8109 19.0542ZM29.5073 44.25C30.9581 44.25 32.1342 43.0747 32.1342 41.625C32.1342 40.1753 30.9581 39 29.5073 39C28.0566 39 26.8805 40.1753 26.8805 41.625C26.8805 43.0747 28.0566 44.25 29.5073 44.25ZM42.6415 41.625C42.6415 43.0747 41.4654 44.25 40.0147 44.25C38.5639 44.25 37.3878 43.0747 37.3878 41.625C37.3878 40.1753 38.5639 39 40.0147 39C41.4654 39 42.6415 40.1753 42.6415 41.625ZM50.522 44.25C51.9728 44.25 53.1488 43.0747 53.1488 41.625C53.1488 40.1753 51.9728 39 50.522 39C49.0712 39 47.8952 40.1753 47.8952 41.625C47.8952 43.0747 49.0712 44.25 50.522 44.25Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutrosImoveisCasa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outros-imoveis-casa.734bb9ee.svg";
export { ForwardRef as ReactComponent };